import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {

    constructor() { }

}
